import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AddonImage = ({ addonId, imageName, size = "w-16 h-16" }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    setImageUrl(null);
    
    const fetchImage = async () => {
      try {
        const response = await axios.get(`${API}/api/settings/addon-products/${addonId}/image`, {
          responseType: 'blob'
        });
        const url = URL.createObjectURL(response.data);
        setImageUrl(url);
        setLoading(false);
      } catch (err) {
        console.error('Failed to load addon image:', err);
        setError(true);
        setLoading(false);
      }
    };

    if (addonId) {
      fetchImage();
    } else {
      setLoading(false);
      setError(true);
    }

    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [addonId]);

  if (loading) {
    return (
      <div className={`${size} bg-gray-100 flex items-center justify-center text-gray-400 rounded animate-pulse`}>
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    );
  }

  if (error || !imageUrl) {
    return (
      <div className={`${size} bg-gray-100 flex items-center justify-center text-gray-400 rounded`}>
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    );
  }

  return (
    <img 
      src={imageUrl} 
      alt={imageName || 'Add-on'} 
      className={`${size} object-cover rounded`}
    />
  );
};

export default AddonImage;
